import React from 'react';
import styles from './MfImportSteps.module.css';
import { CheckedIcon } from 'features/compositions/assets/icons/icons';
import useTheme from 'config/useTheme';
import { useMfImport } from 'features/compositions/context/MfImportContext';

const MfImportSteps = () => {
    const { dark } = useTheme();

    const { step: currentStep, setStep: setCurrentStep } = useMfImport();

    const selectStep = (thisStep) => {
        if (thisStep < currentStep) {
            setCurrentStep(thisStep);
        }
    }

    return (
        <div className={`${styles.mf_import_steps} ${dark ? styles.dark : ''}`}>
            <button
                onClick={() => selectStep(1)}
                className={`${styles.step_group} ${currentStep === 1 ? styles.active : currentStep > 1 ? styles.completed : ''}`}
            >
                {currentStep >= 1 && <CheckedIcon />}
                <span>File import</span>
            </button>
            <div className={`${styles.steps_connector} ${currentStep > 1 ? styles.steps_connector_completed : ''}`}></div>

            <button
                onClick={() => selectStep(2)}
                className={`${styles.step_group} ${currentStep === 2 ? styles.active : currentStep > 2 ? styles.completed : ''}`}
            >
                {currentStep >= 2 && <CheckedIcon />}
                <span>Composition select</span>
            </button>
            <div className={`${styles.steps_connector} ${currentStep > 2 ? styles.steps_connector_completed : ''}`}></div>

            <button
                onClick={() => selectStep(3)}
                className={`${styles.step_group} ${currentStep === 3 ? styles.active : currentStep > 3 ? styles.completed : ''}`}
            >
                {currentStep >= 3 && <CheckedIcon />}
                <span>Authorization</span>
            </button>
            <div className={`${styles.steps_connector} ${currentStep > 3 ? styles.steps_connector_completed : ''}`}></div>

            <button
                onClick={() => selectStep(4)}
                className={`${styles.step_group} ${currentStep === 4 ? styles.active : currentStep > 4 ? styles.completed : ''}`}
            >
                {currentStep >= 4 && <CheckedIcon />}
                <span>Data transmission</span>
            </button>
        </div>
    )
}

export default MfImportSteps;